import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { sportsSocket } from "../../../../utils/socketUtil.js";
import { setSportsData, setOddsData } from "../../../../redux/sports/actions";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import BottomNav from "../../../../containers/BottomNav";
import LeftBarSports from "../../../components/LeftBarSports.js";
import RightBarCasino from "../../../components/RightBarCasino.js";
import SupportDeposit from "../../../../assets/images/support-depsoit.jpg";
import SupportWithdrawal from "../../../../assets/images/support-withdraw.jpg";
import CricketSportsbanner from "../../../../assets/images/sports-btns-new/Button-Cricket.png";
import FootballSportsbanner from "../../../../assets/images/sports-btns-new/Button-Football.png";
import TennisSportsbanner from "../../../../assets/images/sports-btns-new/Button-Tennis.png";
import populargames from "../../../../assets/images/icons/home/popular-3d.png";
import AuraPlay from "../../../../assets/images/icons/home/aura-3d.png";
import casinogames from "../../../../assets/images/icons/home/provider-3d.png";
import ExchangeIcon from "../../../../assets/images/icons/header/exchange.png";
import LiveCasinoIcon from "../../../../assets/images/icons/header/casino.png";
import SlotsIcon from "../../../../assets/images/icons/header/slots.png";
import AviatorIcon from "../../../../assets/images/icons/header/aviator_.png";
import casino1 from "../../../../assets/images/casino/provider/Ezugi.jpg";
import casino2 from "../../../../assets/images/casino/provider/Evolution.jpg";
import casino3 from "../../../../assets/images/casino/provider/Vivogaming.jpg";
import casino4 from "../../../../assets/images/casino/provider/Supernowa.jpg";
import casino5 from "../../../../assets/images/casino/provider/WorldCasino.jpg";
import casino6 from "../../../../assets/images/casino/provider/XPG.jpg";
import casino7 from "../../../../assets/images/casino/provider/virtualsports.jpg";
import casino8 from "../../../../assets/images/casino/provider/OneTouch.jpg";
import casino9 from "../../../../assets/images/casino/provider/Paragmatic.jpg";
import casino10 from "../../../../assets/images/casino/provider/Qtech.jpg";
import { showbetSlip } from "../../../../redux/sports/actions";
import BetSlip from "../../../components/betSlip";
import { betSlipContent } from "../../../../redux/sports/actions";
import BackIcon from "../../../../assets/images/back-icon.png";
import MainSlider from "../../../../containers/MainSlider.js";
import { getBanners } from "../../../../redux/app/actions.js";
import ExchangeLobbyPage from "../exchange/ExchangeLobbyPage.js";
import { isMobile } from "react-device-detect";
import { APP_CONST } from "../../../../config/const.js";
import LoginModal from "../../../components/authModals/LoginModal.js";
import MobileNumberModal from "../../../components/authModals/MobileNumberModal.js";
import MobileNumberVerifyModal from "../../../components/authModals/MobileNumberVerifyModal.js";
import RegisterModal from "../../../components/authModals/RegisterModal.js";
import WhatsappGif from "../../../../assets/images/whatsappGif.gif";
import { popularTabs } from "../../../../lib/data/popularTabs.data.js";

const Sports = ({ isAuth }) => {
  const { banners } = useSelector((state) => state.app);
  const popularGames = popularTabs.popularetab;

  useEffect(() => {
    dispatch(getBanners());
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("2");
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports
  );
  const { appDetails } = useSelector((state) => state.app);

  // useEffect(() => {
  //   sportsSocket.on("markets", (data) => {
  //     // console.log("data", data);
  //     dispatch(setSportsData(data.markets));
  //   });
  //   sportsSocket.on("marketodds", (data) => {
  //     // console.log("data", data);
  //     // console.log("data", data);
  //     dispatch(setOddsData(data.marketOdds));
  //   });
  //   return () => {
  //     sportsSocket.off();
  //   };
  // }, []);

  useEffect(() => {
    if (location?.state?.selectedTab) {
      console.log("location?.state?.selectedTab", location?.state?.selectedTab);
      setActiveKey(location.state.selectedTab);
    }
  }, [location]);

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };

  const handleBetSlip = (value) => {
    //dispatch(showbetSlip(value));
  };

  const handleBetSlipContent = (data) => {
    // dispatch(betSlipContent(data));
  };

  const [showAuthModals, setShowAuthModals] = useState({
    login: false,
    register: false,
    mobileNumber: false,
    verifyNumber: false,
  });
  const handleModalShow = (modalName) => {
    setShowAuthModals((p) => ({ ...p, [modalName]: true }));
  };
  const handleModalClose = (modalName) => {
    setShowAuthModals((p) => ({ ...p, [modalName]: false }));
  };

  const settings = {
    arrows: false,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,

    slidesToShow: 2,
    slidesToScroll: 1,

    speed: 3000,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  const tabs = [
    {
      id: 1,
      eventKey: "1",
      name: "In play",
    },
    {
      id: 2,
      eventKey: "2",
      name: "Cricket",
    },
    {
      id: 3,
      eventKey: "3",
      name: "Soccer",
    },
    {
      id: 4,
      eventKey: "4",
      name: "Tennis",
    },
  ];

  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main home-page d-flex">
        <LeftBarSports />

        <div className="middleContentSec">
          <div className="middleSec">
            <div className="sports_page_banner">
              <MainSlider banners={banners} />
            </div>

            <div className="container">
              <div className="sport-buttons d-md-none">
                <ul>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sportsbook/Cricket");
                      }}
                    >
                      <img
                        src={CricketSportsbanner}
                        alt="cricket-sports-banner"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sportsbook/Soccer");
                      }}
                    >
                      <img
                        src={FootballSportsbanner}
                        alt="Football-sports-banner"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sportsbook/Tennis");
                      }}
                    >
                      <img
                        src={TennisSportsbanner}
                        alt="Tennis-sports-banner"
                      />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="home-iframe d-none">
                {isAuth ? (
                  <div>
                    <ExchangeLobbyPage />
                  </div>
                ) : (
                  <div className="beforelogin-iframe">
                    <iframe src="https://design.powerplay247.com/auth" />
                  </div>
                )}
              </div>

              <div className="facts-sec">
                <ul>
                  <li>
                    <a href="/sportsbook/Inplay">
                      <img src={ExchangeIcon} alt="exchange" />
                      <h6>Exchange</h6>
                      <p>Ride The Sports Exchange To Victory!</p>
                    </a>
                  </li>
                  <li>
                    <a href="/Casino">
                      <img src={LiveCasinoIcon} alt="live casino" />
                      <h6>Live Casino</h6>
                      <p>
                        Real-Time Thrill, <br /> Instant Wins!
                      </p>
                    </a>
                  </li>
                  <li>
                    <a href="/slots">
                      <img src={SlotsIcon} alt="slots" />
                      <h6>Slots</h6>
                      <p>Spin To Win In The Reels Of Fortune!</p>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/spribe/aviator">
                      <img
                        src={AviatorIcon}
                        alt="aviator"
                        className="aviator"
                      />
                      <h6>Aviator</h6>
                      <p>
                        Soar High, <br /> Win Bigger!
                      </p>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="casino-games populaGamesSection">
                <div className="game-heading">
                  <h3>
                    <img src={populargames} alt="popular-games-icon" />
                    Popular Games
                  </h3>
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      !isAuth
                        ? isMobile
                          ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                          : (window.location.href = "/sign-in")
                        : (window.location.href = "/casino/evolution");
                    }}
                    className="openbets"
                  >
                    Evolution
                  </a>
                </div>
                <ul className="exchangeGames-content">
                  {Object.values(popularGames).map((game) =>
                    Object.values(game).map((item) => (
                      <li key={item?.code} className="exchangeitems-item">
                        <a href={item?.redirectUrl}>
                          <img
                            src={item?.imgUrl}
                            alt={item?.alt}
                            className="exchangeGames-img-body"
                          />
                        </a>
                      </li>
                    ))
                  )}
                </ul>
              </div>

              <div className="casino-games populaGamesSection">
                <div className="game-heading">
                  <h3>
                    <img src={casinogames} alt="casino-games-icon" />
                    Casino
                  </h3>
                </div>
                <ul className="exchangeGames-content">
                  <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/ezugi");
                      }}
                    >
                      <img
                        src={casino1}
                        alt="gameimage1"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li>
                  <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/evolution");
                      }}
                    >
                      <img
                        src={casino2}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li>
                  <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/vivo");
                      }}
                    >
                      <img
                        src={casino3}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li>
                  <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/supernowa");
                      }}
                    >
                      <img
                        src={casino4}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li>
                  <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/xpg");
                      }}
                    >
                      <img
                        src={casino6}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li>
                  <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/worldcasino");
                      }}
                    >
                      <img
                        src={casino5}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li>
                  {/* <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sports");
                      }}
                      >
                      <img
                        src={casino7}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li> */}
                  {/* <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/onetouch");
                      }}
                      >
                      <img
                        src={casino8}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li> */}
                  {/* <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/pragamticplay");
                      }}
                      >
                      <img
                        src={casino9}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li> */}
                  {/* <li className="exchangeGames-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/casino/qtech");
                      }}
                    >
                      <img
                        src={casino10}
                        alt="gameimage2"
                        className="exchangeGames-img-body"
                      />
                    </a>
                  </li> */}
                </ul>
              </div>

              <div className="sport-buttons d-none d-md-block">
                <ul>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sportsbook/Cricket");
                      }}
                    >
                      <img
                        src={CricketSportsbanner}
                        alt="cricket-sports-banner"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sportsbook/Soccer");
                      }}
                    >
                      <img
                        src={FootballSportsbanner}
                        alt="Football-sports-banner"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        !isAuth
                          ? isMobile
                            ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                            : (window.location.href = "/sign-in")
                          : (window.location.href = "/sportsbook/Tennis");
                      }}
                    >
                      <img
                        src={TennisSportsbanner}
                        alt="Tennis-sports-banner"
                      />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="support-buttons">
                <ul>
                  <li>
                    <a
                      href={
                        appDetails?.WHATS_APP_URL != ""
                          ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                          : "#"
                      }
                      target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                    >
                      <img src={SupportDeposit} alt="Deposit-support-banner" />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        appDetails?.WHATS_APP_URL != ""
                          ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                          : "#"
                      }
                      target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                    >
                      <img
                        src={SupportWithdrawal}
                        alt="Withdrawal-support-banner"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {!isAuth ? <BeforeLoginFooter /> : <Footer />}
        </div>

        <div className="WhatsappGif">
          <a
            href={
              appDetails?.WHATS_APP_URL != ""
                ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                : "#"
            }
            target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
          >
            <img src={WhatsappGif} alt="Withdrawal-support-banner" />
          </a>
        </div>

        <RightBarCasino />

        <BottomNav />
      </main>

      <LoginModal
        show={showAuthModals.login}
        handleClose={() => handleModalClose(APP_CONST.AUTH_MODAL.LOGIN)}
        handleModalShow={handleModalShow}
      />
      {showAuthModals.mobileNumber && (
        <MobileNumberModal
          show={showAuthModals.mobileNumber}
          handleClose={() =>
            handleModalClose(APP_CONST.AUTH_MODAL.MOBILE_NUMBER)
          }
          handleModalShow={handleModalShow}
        />
      )}
      {showAuthModals.verifyNumber && (
        <MobileNumberVerifyModal
          show={showAuthModals.verifyNumber}
          handleClose={() =>
            handleModalClose(APP_CONST.AUTH_MODAL.VERIFY_NUMBER)
          }
          handleModalShow={handleModalShow}
        />
      )}
      {showAuthModals.register && (
        <RegisterModal
          show={showAuthModals.register}
          handleClose={() => handleModalClose(APP_CONST.AUTH_MODAL.REGISTER)}
          handleModalShow={handleModalShow}
        />
      )}
    </>
  );
};

export default Sports;
